import { Grid, Typography } from '@mui/material';
import { styles } from './styles';

interface IModalHeader {
  heading: string;
  subheading?: string;
}

export const ModalHeader = ({ heading, subheading }: IModalHeader) => {
  return (
    <Grid sx={styles.header}>
      <Grid container alignItems="center">
        <Typography sx={styles.headerTitle}>{heading}</Typography>
        {subheading && <Typography sx={styles.headerSubtitle}>{subheading}</Typography>}
      </Grid>
    </Grid>
  );
};
